import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";

const BlogsCardSkeleton = () => {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        backgroundColor: "white",
      }}
    >
      {/* Image Container Skeleton */}
      <Box
        sx={{
          position: "relative",
          height: 200,
          overflow: "hidden",
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ borderRadius: 0 }}
        />
        
        {/* Category Chip Skeleton */}
        <Skeleton
          variant="rectangular"
          width={80}
          height={24}
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            borderRadius: "12px",
          }}
        />
      </Box>

      {/* Content Container Skeleton */}
      <Box sx={{ p: 2.5 }}>
        {/* Date and Reading Time Skeleton */}
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton
              variant="text"
              width={80}
              height={16}
              sx={{ borderRadius: "4px" }}
            />
          </Stack>
        </Stack>

        {/* Title Skeleton */}
        <Skeleton
          variant="text"
          width="90%"
          height={24}
          sx={{ mb: 1.5, borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          width="70%"
          height={24}
          sx={{ mb: 1.5, borderRadius: "4px" }}
        />

        {/* Description Skeleton */}
        <Skeleton
          variant="text"
          width="100%"
          height={18}
          sx={{ mb: 1, borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          width="95%"
          height={18}
          sx={{ mb: 1, borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          width="85%"
          height={18}
          sx={{ borderRadius: "4px" }}
        />
      </Box>
    </Box>
  );
};

export default BlogsCardSkeleton;